import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { api, LEVEL_LABELS } from '@/lib/api';
import { Timer, FileQuestion, ArrowRight } from 'lucide-react';

export default function QuizIntroPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const level = location.state?.level;
  const [config, setConfig] = useState(null);

  useEffect(() => {
    if (!level) { navigate('/'); return; }
    api.get('/config/public').then(r => setConfig(r.data)).catch(() => navigate('/'));
  }, [level, navigate]);

  if (!level || !config) return null;

  const qCount = config.questionsPerRun?.[level] || 15;
  const timePerQ = config.timePerQuestionOverrides?.[level] || config.timePerQuestionSeconds || 20;

  return (
    <div className="flex-1 flex items-center justify-center px-4 py-4 sm:py-0" data-testid="quiz-intro-page">
      <div className="animate-fade-up glass-card rounded-2xl p-6 sm:p-12 max-w-md w-full text-center">
        <div className="inline-block px-3 sm:px-4 py-1 sm:py-1.5 rounded-full bg-[#3B82F6]/15 text-[#60A5FA] font-outfit font-bold text-xs sm:text-sm mb-4 sm:mb-6">
          {LEVEL_LABELS[level]}
        </div>

        <h2 className="font-outfit font-bold text-xl sm:text-3xl text-white mb-5 sm:mb-8">Quiz starten</h2>

        <div className="grid grid-cols-2 gap-3 sm:gap-4 mb-5 sm:mb-8">
          <div className="bg-white/5 rounded-xl p-3 sm:p-4">
            <FileQuestion className="w-5 sm:w-6 h-5 sm:h-6 text-[#3B82F6] mx-auto mb-1 sm:mb-2" />
            <p className="text-xl sm:text-2xl font-outfit font-bold text-white">{qCount}</p>
            <p className="text-[10px] sm:text-xs text-[#9CA3AF]">Fragen</p>
          </div>
          <div className="bg-white/5 rounded-xl p-3 sm:p-4">
            <Timer className="w-5 sm:w-6 h-5 sm:h-6 text-[#F59E0B] mx-auto mb-1 sm:mb-2" />
            <p className="text-xl sm:text-2xl font-outfit font-bold text-white">{timePerQ}s</p>
            <p className="text-[10px] sm:text-xs text-[#9CA3AF]">pro Frage</p>
          </div>
        </div>

        <Button
          onClick={() => navigate('/quiz/play', { state: { level } })}
          className="w-full h-12 sm:h-14 bg-[#3B82F6] hover:bg-[#2563EB] text-white font-outfit font-bold text-base sm:text-lg rounded-xl transition-all hover:-translate-y-0.5"
          data-testid="quiz-start-btn"
        >
          Start <ArrowRight className="w-4 sm:w-5 h-4 sm:h-5 ml-2" />
        </Button>
      </div>
    </div>
  );
}
